






import {
  Vue,
  Component,
  Prop
} from "@/shared/vuepack";

@Component
export default class Widget extends Vue {
  @Prop()
  type: string;
}
